
import Vue from 'vue'

export default Vue.extend({
  props: ['text', 'item', 'openDeleteDialog'],
})
